<template>
	<div class="panel-date bg-color-skin-light-30">
	  <div class="col-xs-12 align-center">
	    <label> {{ showTabDate }} </label>
	  </div>
	</div>
</template>

<script>
export default {
  name: 'filter_date',
  props: ['showTabDate']
}
</script>

<style lang="scss">
.panel-date {
	display: none; // should fix
	height: 40px;
	padding: 8px 0;
	background-color:#d6e8ec;
	font-size: 19px;
	color: #1ba39c;
	label {
		font-weight: bold;
	}
}
</style>


// WEBPACK FOOTER //
// filter_date.vue?1f698916